// Domain
const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.kyc.landing.modal.description.';

const KYC_LANDING_MODAL_ACCOUNT_CHECK = {
    feature_01: `${DOMAIN}accountCheckFeature01`,
    feature_02: `${DOMAIN}accountCheckFeature02`,
    feature_03: `${DOMAIN}accountCheckFeature03`,
  },
  KYC_LANDING_MODAL_BIZUM = {
    feature_01: `${DOMAIN}bizumFeature01`,
    feature_02: `${DOMAIN}bizumFeature02`,
    feature_03: `${DOMAIN}bizumFeature03`,
  },
  KYC_LANDING_MODAL_VIDEOCALL = {
    feature_01: `${DOMAIN}videocallFeature01`,
    feature_02: `${DOMAIN}videocallFeature02`,
    feature_03: `${DOMAIN}videocallFeature03`,
  },
  KYC_LANDING_MODAL_VIDEOCALL_DESCRIPTION = `${DOMAIN}videocallDescription`,
  KYC_LANDING_MODAL_BIZUM_DESCRIPTION = `${DOMAIN}bizumDescription`;

export {
  KYC_LANDING_MODAL_ACCOUNT_CHECK,
  KYC_LANDING_MODAL_BIZUM,
  KYC_LANDING_MODAL_BIZUM_DESCRIPTION,
  KYC_LANDING_MODAL_VIDEOCALL,
  KYC_LANDING_MODAL_VIDEOCALL_DESCRIPTION,
};
